import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../../components/panel/panel.jsx";
import { getActions, saveAction } from "../../../services/forumcategories.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "../../../common/pagination";
import { paginate } from "../../../utils/paginate";
import TicketsTable from "../../../components/ticketsTable.jsx";
import SearchBox from "../../../common/searchBox";
import _ from "lodash";
import http from "../../../services/httpService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Icons imports
import newIcon from "../../../assets/Icons/new.svg";
import eyeIcon from "../../../assets/Icons/eye.svg";
import editIcon from "../../../assets/Icons/edit.svg";
import trashIcon from "../../../assets/Icons/trash.svg";
import csvIcon from "../../../assets/Icons/csv.svg";
import xlsIcon from "../../../assets/Icons/xls.svg";
import pdfIcon from "../../../assets/Icons/pdf.svg";
import sharingIcon from "../../../assets/Icons/sharing.svg";
import archiveIcon from "../../../assets/Icons/archive.svg";

import Icon from '../../../common/icon';
import ForumCategoriesTable from "./forumCategoriesTable.jsx";

const apiUrl = process.env.REACT_APP_API_URL;

class ForumCategoriesTableData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forumCategories: [],
            pageSize: 10,
            currentPage: 1,
            sortColumn: { path: "title", order: "asc" },
            searchQuery: "",
            errors: {},
            checkedFields: [],
        };

        this.handleDelete = this.handleDelete.bind(this);
        this.handleMassDelete = this.handleMassDelete.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    // toggle() {
    // 	this.setState((prevState) => ({
    // 		toggleModal: !prevState.toggleModal,
    // 	}));
    // }

    async componentDidMount() {
        document.title = "ForumCategories";
        const { data } = await getActions();
        this.setState({ forumCategories: data });
    }

    //sorting columns
    handleSort = (sortColumn) => {
        this.setState({ sortColumn });
    };
    handlePageChange = (page) => {
        console.log(page);
        this.setState({ currentPage: page });
    };

    handleSearch = (query) => {
        console.log(query);
        this.setState({ searchQuery: query, currentPage: 1 });
    };

    getDataPgnation = () => {
        const { pageSize, currentPage, forumCategories: ForumCategories, sortColumn, searchQuery } = this.state;

        //filter maybe next time
        let filtered = ForumCategories;
        if (searchQuery) {
            console.log(searchQuery);
            filtered = ForumCategories.filter(
                (el) =>
                    el.email.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.ticketNo.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.name.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.participants.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.priority.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.category.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.businessName.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
                    el.username.toLowerCase().startsWith(searchQuery.toLowerCase())
            );
        }

        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
        const forumCategories = paginate(sorted, currentPage, pageSize);
        return { data: forumCategories };
    };

    handleDelete = async (cat) => {
        ///delete
        const orignalCategories = this.state.forumCategories;
        const forumCategories = this.state.forumCategories.filter((Cat) => Cat._id !== cat._id);
        this.setState({ forumCategories });
        try {
            await http.delete(apiUrl + "/forumcategories/" + cat._id);
        } catch (ex) {
            //ex.request
            //ex.response

            if (ex.response && ex.response === 404) {
                alert("already deleted");
            }

            this.setState({ forumCategories: orignalCategories });
        }
    };

    handleCheckboxChange = ({ target: { checked, value } }) => {
        if (checked) {
            this.setState(({ checkedFields }) => ({
                checkedFields: [...checkedFields, value],
            }));
        } else {
            this.setState(({ checkedFields }) => ({
                checkedFields: checkedFields.filter((e) => e !== value),
            }));
        }
        console.log("checked users: ", this.state.checkedFields);
    };

    handleSelectAll = (event) => {
        const { data: forumCategories } = this.getDataPgnation();
        if (event.target.checked) {
            // If the checkbox is checked, select all items
            this.setState({ checkedFields: forumCategories.map(item => item._id) });
        } else {
            // If the checkbox is unchecked, clear the selection
            this.setState({ checkedFields: [] });
        }
    };

    handleMassDelete = async (checkedFields) => {


        const originalCategories = this.state.forumCategories;

        // Optimistically remove the checked items from state
        const forumCategories = originalCategories.filter(
            (cat) => !checkedFields.includes(cat._id)
        );
        this.setState({ forumCategories, checkedFields: [] });

        try {
            // Use Promise.all to delete all items in parallel
            await Promise.all(
                checkedFields.map(catId =>
                    http.delete(apiUrl + "/forumcategories/" + catId)
                )
            );


        } catch (ex) {
            // Restore original state on error
            this.setState({
                forumCategories: originalCategories,
                checkedFields: checkedFields // Keep the original checked fields for retry
            });

            // Proper error handling
            if (ex.response && ex.response.status === 404) {
                alert("One or more categories were already deleted");
            } else if (ex.response && ex.response.status) {
                alert(`Error: ${ex.response.status} - ${ex.response.statusText}`);
            } else {
                alert("Network error occurred. Please try again.");
            }
            console.error("Mass delete error:", ex);
        }
    };

    render() {
        const { length: count } = this.state.forumCategories;
        const { pageSize, currentPage, sortColumn, searchQuery, checkedFields } = this.state;
        //if (count === 0) return <p>No data available</p>;

        const { data: forumCategories } = this.getDataPgnation();

        return (
            <div>
                <ol className="breadcrumb float-xl-right">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                        <Link to="/">ForumCategories</Link>
                    </li>
                    <li className="breadcrumb-item active">ForumCategories Tables</li>
                </ol>
                <h1 className="page-header">ForumCategories </h1>
                <Panel>
                    <PanelHeader>ForumCategories Management</PanelHeader>

                    <React.Fragment>
                        <ToastContainer />
                        <div className="toolbar" style={toolbarStyles}>
                            <Icon
                                to="/forum/forumcategories/new"
                                title="add ticket"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={newIcon}
                            />

                            <Icon
                                to={checkedFields ? `/forum/forumcategories/${checkedFields[0]}` : "/forum/forumcategories/"}
                                title="edit ticket"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={editIcon}
                            />
                            <Icon
                                handleClick={() => this.handleMassDelete(checkedFields)}
                                title="delete forumCategories"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={trashIcon}
                            />
                            <Icon
                                to="/forum/forumcategories/"
                                title="Excel"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={xlsIcon}
                            />
                            <Icon
                                to="/forum/forumcategories/"
                                title="CSV"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={csvIcon}
                            />
                            <Icon
                                to="/forum/forumcategories/"
                                title="PDF"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={pdfIcon}
                            />
                            <Icon
                                to="/forum/forumcategories/"
                                title="Share to other"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={sharingIcon}
                            />
                            <Icon
                                to="/forum/forumcategories/"
                                title="Archive ticket"
                                btnStyle={btnStyles}
                                iconStyle={iconStyles}
                                icon={archiveIcon}
                            />

                        </div>

                        <div className="table-responsive">
                            <SearchBox value={searchQuery} onChange={this.handleSearch} />
                            <p
                                className="page-header float-xl-left"
                                style={({ marginBottom: 5 }, { marginLeft: 20 }, { marginTop: 5 })}
                            >
                                {count} entries
                            </p>

                            <ForumCategoriesTable
                                forumCategories={forumCategories}
                                onDelete={this.handleDelete}
                                onSort={this.handleSort}
                                sortColumn={sortColumn}
                                handleCheckboxChange={this.handleCheckboxChange}
                                handleSelectAll={this.handleSelectAll}
                                checkedFields={this.state.checkedFields}
                            />
                        </div>
                    </React.Fragment>

                    <hr className="m-0" />
                    <PanelBody>
                        <div className="d-flex align-items-center justify-content-center">
                            <Pagination
                                itemsCount={count}
                                pageSize={pageSize}
                                onPageChange={this.handlePageChange}
                                currentPage={currentPage}
                            />
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        );
    }
}

const toolbarStyles = {
    background: "#c8e9f3",
    padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
    width: "25px",
    height: "25px",
    marginRight: "0rem",
};
export default ForumCategoriesTableData;
